import { regionToCountries } from '@/data/regionCountryMap' // adjust to your path

export type ContinentCode = 'EU' | 'NA' | 'SA' | 'AS' | 'AF' | 'ME' | 'OC' | 'OT'
export type ContinentCountries = Record<ContinentCode, string[]>

const uniqUpper = (xs: string[]): string[] =>
  Array.from(new Set(xs.map((x) => String(x).toUpperCase()).filter((x) => x.length === 2)))

const pickByPrefix = (prefix: string): string[] =>
  Object.entries(regionToCountries)
    .filter(([k]) => k.includes(prefix))
    .flatMap(([, v]) => v)

// Build the fallback mapping from regionToCountries once at module load.
// Used when the backend doesn't provide `continentCountries` in the aggregate.
const ME = regionToCountries['Middle East'] ?? []
const AS = [
  ...pickByPrefix('Asia'),
  // Some providers put Middle East under Asia; keep it separate so ME can be styled independently.
  ...pickByPrefix('Western Asia').filter((cc) => !ME.includes(cc)),
]
const EU = pickByPrefix('Europe')
const AF = pickByPrefix('Africa')
const OC = pickByPrefix('Australia and New Zealand')
const NA = pickByPrefix('Northern America')
const SA = [
  ...pickByPrefix('Central America'),
  ...pickByPrefix('Caribbean'),
  ...pickByPrefix('South America'),
]

export const FALLBACK_CONTINENT_COUNTRIES: ContinentCountries = {
  EU: uniqUpper(EU),
  NA: uniqUpper(NA),
  SA: uniqUpper(SA),
  AS: uniqUpper(AS),
  AF: uniqUpper(AF),
  ME: uniqUpper(ME),
  OC: uniqUpper(OC),
  OT: [],
}

// Resolve continent→countries from server data when available, else fall back.
export function resolveContinentCountries(
  fromAgg: Record<string, string[]> | undefined,
): Record<string, string[]> {
  if (fromAgg && typeof fromAgg === 'object') return fromAgg
  return FALLBACK_CONTINENT_COUNTRIES
}
